import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';


// The purpose of this service is to inform about updates in the device canvas,
// mainly when new messages are received from the device via websocket.
// Specially, in the context of simulation overlay for vision-impairment, we want to
// update the overlay only when there is something new from the device.

// As the service provides a communication channel from a specific device,
// we don't want a singleton injected everywhere. That would required device-id book-keeping.
// Therefore, the service is intended to be provided lower in the component hierarchy
// to have an unique instance per device, i.e via 'providers' field in @Component.
// For detail: https://angular.dev/guide/di/defining-dependency-providers#injector-hierarchy-in-angular


export interface WorkbenchDeviceUpdate {
    newImage: boolean;
    newRotation: boolean;
    rotation: number;
}

@Injectable()
export class WorkbenchDeviceUpdateNotificationService {
    private notifySubject = new BehaviorSubject<WorkbenchDeviceUpdate>({newImage: true, newRotation: true, rotation: 0});
    private rotationSubject = new BehaviorSubject<{current: number, desired: number | null}>({current: 0, desired: null});
    workbenchDeviceUpdateNotification$ = this.notifySubject.asObservable();
    workbenchDeviceRotation$ = this.rotationSubject.asObservable();

    notifyUpdate(update: WorkbenchDeviceUpdate) {
        this.notifySubject.next(update);
    }

    setRotation(currentRotation: number, desiredRotation: number | null = null) {
        const rotation = {current: currentRotation, desired: desiredRotation};
        this.rotationSubject.next(rotation);
    }
}